// @flow
import type { AxiosPromise } from "axios";
import { api } from "./api";
import type { FormType } from "../form/types";
import type { Event } from "../entities/event.type";
import type { Department } from "../entities/department.type";
import type { Region } from "../entities/region.type";
import type { NatureType } from "../entities/natureType.type";
import type { NetworkType } from "../entities/networkType.type";
import type { MediaObject } from "../entities/mediaObject.type";

type Type<T> = {
    "@context": string,
    "@id": string,
    "@type": string,
    "hydra:member": T,
};

class MapAPI {
    static postEvent = (data: ?FormType): AxiosPromise<Type<Array<Event>>> =>
        api.post("events", data);

    static postMedias = (data: mixed): AxiosPromise<Type<Array<MediaObject>>> =>
        api.post("media_objects", data);

    static getRegions = (): AxiosPromise<Type<Array<Region>>> =>
        api.get("regions");

    static getDepartments = (): AxiosPromise<Type<Array<Department>>> =>
        api.get("departments");

    static getNatureTypes = (): AxiosPromise<Type<Array<NatureType>>> =>
        api.get("nature-types");

    static getNetworkTypes = (): AxiosPromise<Type<Array<NetworkType>>> =>
        api.get("network-types?active=true");

    static getStructureTypes = (): AxiosPromise<Type<Array<Event>>> =>
        api.get("structure-types");
}

export default MapAPI;
